import React, { Component } from 'react'
import { translate } from 'react-polyglot'
import { reduxForm } from 'redux-form'
import Clipboard from 'react-clipboard.js'
import Tippy from '@tippy.js/react'

import {
	Modal,
	ButtonGroup,
	Button,
	Avatar,
	Icon,
	FlexContainer,
	Text,
	Confirm,
	Label,
	Table,
	FilterInput,
} from 'components'

import { Select } from 'components/FormField'
import InviteMembersForm from './InviteMembersForm'

import './memberForm.scss'

class MembersForm extends Component {
	constructor(props) {
		super(props)

		this.state = {
			search: '',
			inviteMembersModalOpen: props.openInvites,
		}
	}

	onCreate = tippy => {
		this.tippy = tippy
	}

	closeTippy = () => {
		this.tippy.hide()
	}

	toggleInviteMembersModal = () => {
		const { inviteMembersModalOpen } = this.state

		this.setState({ inviteMembersModalOpen: !inviteMembersModalOpen })
	}

	handleInviteMembersSubmit = values => {
		const { createInvites } = this.props

		// @TODO: Improve -> send one array of objects
		// Another problem: achievement gets triggered multiple times
		values.invites.forEach(invite => {
			createInvites({
				email: invite.email,
				role: invite.role,
			})
		})

		this.toggleInviteMembersModal()
	}

	render() {
		const { search } = this.state

		const { inviteMembersModalOpen } = this.state

		const {
			userId,
			members,
			updateTeamMember,
			removeTeamMember,
			updateInvite,
			removeInvite,
			reinvite,
			t,
		} = this.props

		const options = [
			{
				value: 100,
				label: t('settings.user'),
				description: t('settings.user_description'),
			},
			{
				value: 200,
				label: t('settings.billing_admin'),
				description: t('settings.billing_admin_description'),
			},
			{
				value: 300,
				label: t('settings.admin'),
				description: t('settings.admin_description'),
			},
		]

		let m = members

		if (search) {
			m = members.filter(
				row =>
					(row.firstName &&
						row.firstName
							.toLowerCase()
							.includes(search.toLowerCase())) ||
					(row.lastName &&
						row.lastName
							.toLowerCase()
							.includes(search.toLowerCase())) ||
					(row.email &&
						row.email.toLowerCase().includes(search.toLowerCase()))
			)

			// || row.isActive.toLowerCase().includes(search.toLowerCase())
			// || row.role.toLowerCase().includes(search.toLowerCase())
		}

		return (
			<>
				<FlexContainer wrap>
					<h2>{t('settings.manage_members')}</h2>
					<FlexContainer justifyContent="flex-start">
						<FilterInput
							name="membersFilter"
							value={search}
							onChange={e =>
								this.setState({ search: e.target.value })
							}
						/>
						<Button
							text={t('settings.invite_users')}
							size="small"
							layout="secondary"
							onClick={() => {
								this.toggleInviteMembersModal()
							}}
						/>
					</FlexContainer>
				</FlexContainer>
				<Table
					data={m}
					columns={[
						{
							Header: t('settings.name'),
							id: 'name',
							accessor: 'email',
							Cell: props =>
								props.original.firstName ? (
									<FlexContainer justifyContent="flex-start">
										<Avatar
											initials={
												props.original.firstName.charAt(
													0
												) +
												props.original.lastName.charAt(
													0
												)
											}
											image={props.original.image}
										/>
										<Text color="dark">
											{props.original.firstName}{' '}
											{props.original.lastName}{' '}
											{userId === props.original.id && (
												<Label
													text={t('settings.you')}
													theme="important"
												/>
											)}
											<br />
											<small>
												{props.original.email}
											</small>
										</Text>
									</FlexContainer>
								) : (
									<Text color="dark">
										{props.original.email}
									</Text>
								),
						},
						{
							Header: t('settings.status'),
							accessor: 'isActive',
							Cell: props => (
								<Label
									theme={
										props.original.invitedAt
											? 'warning'
											: 'success'
									}
									text={
										props.original.invitedAt
											? t('settings.invite_pending')
											: t('settings.active')
									}
								/>
							),
						},
						{
							Header: t('settings.role'),
							accessor: 'role',
							Cell: props =>
								userId === props.original.id ||
								props.original.invitedAt ? (
									<div className="c-member-form__role">
										<Text size="inherit" color="dark">
											{
												options.find(
													option =>
														option.value ===
														props.original.role
												).label
											}
										</Text>
									</div>
								) : (
									<div className="c-member-form__role">
										<div className="c-member-form__role-select">
											<Select
												value={{
													value: props.value,
													label: options.find(
														option =>
															option.value ===
															props.value
													).label,
												}}
												options={options}
												isDisabled={
													props.original.invitedAt
												}
												onChange={e => {
													if (
														props.original.invitedAt
													) {
														updateInvite({
															id:
																props.original
																	.id,
															role: e.value,
														})
													} else {
														updateTeamMember({
															id:
																props.original
																	.id,
															role: e.value,
														})
													}
												}}
												menuPortalTarget={document.getElementById(
													'root'
												)}
											/>
										</div>
									</div>
								),
						},
						{
							Header: '',
							accessor: '',
							sortable: false,
							Cell: props =>
								userId !== props.original.id ? (
									<Tippy
										placement="right-start"
										trigger="click"
										animation="shift-away"
										animateFill={false}
										theme="min-width-small"
										interactive
										a11y={false}
										onCreate={this.onCreate}
										zIndex={999999}
										content={
											<ButtonGroup>
												{props.original.invitedAt && (
													<Button
														text={t(
															'settings.resend_invitation'
														)}
														icon={
															<Icon name="update" />
														}
														layout="tertiary"
														fullWidth
														size="small"
														onClick={() => {
															reinvite(
																props.original
															)
															this.closeTippy()
														}}
													/>
												)}
												{props.original.invitedAt && (
													<Clipboard
														type="button"
														className="o-button o-button--tertiary o-button--small o-button--full-width has-icon is-visible"
														data-clipboard-text={`${process.env.PUBLIC}/invite/?i=${props.original.token}`}
														onSuccess={() =>
															this.closeTippy()
														}
													>
														<span className="o-button__icon">
															<svg className="o-icon o-icon--rte_link">
																<use xlinkHref="#icon--rte_link" />
															</svg>
														</span>
														<span className="o-button__text">
															<span>
																{t(
																	'settings.copy_link'
																)}
															</span>
														</span>
													</Clipboard>

													// <Button
													// 	icon={<Icon name="rte_link" />}
													// 	layout="tertiary"
													// 	fullWidth
													// 	size="small"
													// >
													// 	<Clipboard className="o-button o-button--tertiary o-button--small o-button--icon-only o-button--full-width has-icon is-visible" data-clipboard-text={`https://app.skara.io/invite/?i=${props.original.token}`} onSuccess={() => this.closeTippy()}>
													// 		Copy link
													// 	</Clipboard>
													// </Button>
												)}
												<Confirm
													title={
														props.original.invitedAt
															? t(
																	'settings.really_delete_invitation'
															  )
															: t(
																	'settings.really_delete_user'
															  )
													}
													text={
														props.original
															.invitedAt ? (
															<>
																{t(
																	'settings.delete_invitation_text'
																)}
																<br />
																{t(
																	'settings.delete_invitation_notice'
																)}
															</>
														) : (
															<>
																{t(
																	'settings.delete_user_text'
																)}
																&thinsp;
																<strong>
																	{
																		props
																			.original
																			.firstName
																	}{' '}
																	{
																		props
																			.original
																			.lastName
																	}
																</strong>
																<br />
																{t(
																	'settings.delete_user_notice'
																)}
															</>
														)
													}
													onOpen={() => {
														this.closeTippy()
													}}
												>
													{confirm => (
														<Button
															text={
																props.original
																	.invitedAt
																	? t(
																			'settings.delete_invitation'
																	  )
																	: t(
																			'settings.delete_user'
																	  )
															}
															icon={
																<Icon name="delete" />
															}
															layout="tertiary"
															fullWidth
															size="small"
															onClick={confirm(
																() => {
																	if (
																		props
																			.original
																			.invitedAt
																	) {
																		removeInvite(
																			props
																				.original
																				.id
																		)
																	} else {
																		removeTeamMember(
																			props
																				.original
																				.id
																		)
																	}
																	this.closeTippy()
																}
															)}
														/>
													)}
												</Confirm>
											</ButtonGroup>
										}
									>
										<Button
											tabIndex="-1"
											icon={<Icon name="dot-3" />}
											className="o-text--inline"
										/>
									</Tippy>
								) : null,
						},
					]}
					defaultSorted={[
						{
							id: 'isActive',
							desc: true,
						},
						{
							id: 'name',
						},
					]}
				/>
				<Modal
					visible={inviteMembersModalOpen}
					onClose={this.toggleInviteMembersModal}
					title={t('settings.invite_new_users')}
					width="large"
				>
					<InviteMembersForm
						onSubmit={this.handleInviteMembersSubmit}
						handleReset={this.toggleInviteMembersModal}
						initialValues={{
							invites: [
								{
									email: '',
									role: 100,
								},
							],
						}}
					/>
				</Modal>
			</>
		)
	}
}

export default reduxForm({
	form: 'members',
})(translate()(MembersForm))
